<template>
  <div class="menucate-cls new-catg" @click="menuCategoryId(menu.id)">
    <!-- {{ this.$route.name }} -->
    <div class="rmvecls" :id="'menucateID-' + menu.id" @click="getActiveMenuId(menu.id)"
      v-if="this.$route.name == 'restaurant' || this.$route.name == 'vendor'">
      <!-- v-if="this.$route.name == 'restaurant'"> -->
      <img v-lazy="menu.image" class="menu-cat-img" @error="$event.target.src = noImge">
      <h4 v-if="menu.name" class="item-cat-details-box" :style="{ color: '#fff' + '!important', fontSize: '12px' }">{{
        menu.name }}</h4>
      <!-- <h6 v-else :style="{ color: '#fff' + '!important', fontSize: '14px' }">{{ menu.name }}</h6> -->
    </div>
    <!------------Menu Category 1 Start -------------------->
    <div v-if="cateMenuLayout == '1' && pagename == 'home'"
      class="resturant-item busines-img-box d-flex align-items-start" :style="{
        backgroundImage: 'url(' + menu.image + ')',
        backgroundPosition: 'right',
        backgroundColor: menu.color_code + '!important',
        backgroundRepeat: 'no-repeat'
      }">
      <div class="busines-img">
        <div class="resturant-data mx-0 p-0">
          <!-- <h4
            :style="{ color: (menu.text_color_code == null ? 'var(--theme-font-primary)' : menu.text_color_code) + '!important' }">
            {{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
          <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4>
        </div>
      </div>
    </div>


    <!------------Menu Category 1 Start -------------------->
    <!------------Menu Category 2 Start -------------------->
    <div v-if="cateMenuLayout == '2' && pagename == 'home'" class="resturant-item busines-img-box"
      :style="{ background: menu.color_code + '!important' }">
      <div class="busines-img">
        <div class="img-box">
          <img v-lazy="menu.image" @error="$event.target.src = noImge">
        </div>
        <div class="resturant-data ms-3 pb-0">
          <!-- <h4 :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
        </div>
      </div>
    </div>
    <!------------Menu Category 2 end -------------------->

    <!------------Menu Category 3 Start -------------------->
    <div class="menu-ca" v-if="cateMenuLayout == '3'">
      <div v-if="cateMenuLayout == '3' && pagename == 'home'" class="resturant-item busines-img-box 69 p-0">
        <div class="busines-img">
          <div class="img-box">
            <img v-if="!imgError && menu.image" v-lazy="menu.image" @error="onImgError()">
            <img v-else v-lazy="$auth.getAppLogo()" alt="">
          </div>
          <div class="resturant-data text-center">
            <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
              menu.name }}</h4>
            <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!------------Menu Category 3 end -------------------->

    <!------------Menu Category 4 Start -------------------->
    <div v-if="cateMenuLayout == '4' && pagename == 'home'" class="resturant-item busines-img-box"
      :style="{ background: menu.color_code + '!important' }">
      <div class="busines-img">
        <div class="resturant-data ms-3">
          <!-- <h4 :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
          <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4>
        </div>
        <div class="img-box">
          <img v-lazy="menu.image" @error="$event.target.src = noImge">
        </div>
      </div>
    </div>
    <!------------Menu Category 4 end -------------------->
    <!------------Menu Category 5 Start -------------------->
    <div v-if="cateMenuLayout == '5' && pagename == 'home'" class="resturant-item busines-img-box"
      :style="{ background: menu.color_code + '!important' }">
      <div class="busines-img">
        <div class="img-box">
          <img v-lazy="menu.image" @error="$event.target.src = noImge">
        </div>
        <div class="resturant-data ms-3">
          <!-- <h4 :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
          <!-- <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
        </div>
      </div>
    </div>
    <!------------Menu Category 5 end -------------------->
    <!------------Menu Category 6 Start -------------------->
    <div v-if="cateMenuLayout == '6' && pagename == 'home'" class="resturant-item busines-img-box"
      :style="{ background: menu.color_code + '!important' }">
      <div class="busines-img">
        <div class="resturant-data ms-3">
          <!-- <h4 :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
          <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4>
        </div>
        <div class="img-box">
          <img v-lazy="menu.image" @error="$event.target.src = noImge">
        </div>
      </div>
    </div>
    <!------------Menu Category 6 end -------------------->

    <!------------Menu Category 7 start -------------------->
    <div v-if="cateMenuLayout == '7' && pagename == 'home'"
      class="resturant-item busines-img-boxresturant-item busines-img-box ">
      <div class="busines-img">
        <div class="img-box" :style="{ backgroundColor: menu.color_code }">
          <img :src="menu.image" alt="">
        </div>
        <div class="resturant-data text-center">
          <!-- <h4
              :style="{ color: (menu.text_color_code == null ? 'var(--theme-font-primary)' : menu.text_color_code) + '!important' }">
              {{ menu.name }}</h4> -->
          <h4 class="category_sub-heading text-center" v-if="menu.name"
            :style="{ color: menu.text_color_code + '!important' }">
            {{
              menu.name }}</h4>
          <!-- <h4 class="text-center" v-if="menu.item_counts" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.item_counts }} {{
              $t('items') }}</h4> -->
          <!-- <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
        </div>
      </div>

    </div>
    <!------------Menu Category 7 end -------------------->
    <!------------Menu Category 8 start -------------------->

    <!-- :style="{ background: 'url(' + menu.image + ')', backgroundColor: 'var(--theme-button-secondary-color)  !important', backgroundSize: 'cover !important', backgroundPosition: 'center !important', backgroundRepeat: 'no-repeat !important' }"> -->

    <div v-if="cateMenuLayout == '8' && pagename == 'home'"
      class="resturant-item busines-img-boxresturant-item busines-img-box">
      <div class="busines-img">
        <div class="img-box">
          <img :src="menu.image" alt="">
          <div class="resturant-data" :style="{
            background: `linear-gradient(180deg, rgba(10, 16, 47, 0) 0%, ${menu.color_code} 100%)`
          }">
            <!-- <h4
              :style="{ color: (menu.text_color_code == null ? 'var(--theme-font-primary)' : menu.text_color_code) + '!important' }">
              {{ menu.name }}</h4> -->
            <!-- :style="{ color: menu.text_color_code + '!important' }" -->
            <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
              menu.name }}</h4>
            <!-- <h4 v-if="menu.item_counts" :style="{ color: menu.text_color_code + '!important' }">{{
              menu.item_counts }} {{
                $t('items') }}</h4> -->
            <!-- <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          </div>
        </div>

      </div>
    </div>
    <!------------Menu Category 8 end -------------------->

    <!------------Menu Category 9 start -------------------->

    <div v-if="cateMenuLayout == '9' && pagename == 'home'" class="resturant-item busines-img-box" :style="{
      background: 'linear-gradient(291.82deg, rgba(255,255,255,0) 30%, ' + menu.color_code + ' 200%), #FFFFFF',
      border: '1px solid' + menu.color_code
    }">

      <div class="busines-img">
        <div class="resturant-data ms-3">
          <!-- <h4 :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4> -->
          <h4 class="category_sub-heading" v-if="menu.name" :style="{ color: menu.text_color_code + '!important' }">{{
            menu.name }}</h4>
          <h4 v-else :style="{ color: menu.text_color_code + '!important' }">{{ menu.name }}</h4>
        </div>
        <div class="img-box">
          <img v-lazy="menu.image" @error="$event.target.src = noImge">
        </div>
      </div>
    </div>
  </div>
  <!------------Menu Category 9 end -------------------->
</template>
<script>
import noImge from "@/assets/images/place_holder.png";
export default {

  props: ["menu", "cateMenuLayout", "pagename"],
  data() {
    return {
      loading: true,
      imgError: false,
      noImge,
      isMenuInitialized: false
    };
  },
  methods: {
    onImgError() {
      this.imgError = true;
      this.noImgClass = 'noImgClass';
    },

    getActiveMenuId(id) {
      let element = document.getElementById('menucateID-' + id);
      $(".rmvecls").removeClass("active");
      element.className += " active";
      this.$emit("setCategoryMenuId", id);
    },
    menuCategoryId(id) {
      localStorage.setItem('setMenuCategoryId', id);
    },
  }
}
</script>
<style scoped>
.item-cat-details-box {
  position: absolute;
  bottom: 7px;
  left: 0;
  right: 0;
  width: 80%;
  margin: auto;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; */
  display: inline-block;
  white-space: pre-wrap;
  line-height: 1.3;
}
</style>